module.exports = __webpack_public_path__ + "static/media/url.5155a66a.svg";